module.exports = {"name":"OnboardUser","component":"OnboardUser","clauses":{"newUser":{"en":"New User","jp":"新しいユーザー"},"info":{"en":"Info","jp":"情報"},"uInfo":{"en":"User Information","jp":"ユーザー情報"},"email":{"en":"Email","jp":"メール"},"fName":{"en":"First Name","jp":"名"},"lName":{"en":"Last Name","jp":"姓"},"phoneNum":{"en":"Phone Number","jp":"電話番号"},"sum":{"en":"Summary","jp":"概要"},"back":{"en":"Back","jp":"戻る"},"next":{"en":"Next","jp":"次へ"},"sub":{"en":"Submit","jp":"送信"},"jobTitle":{"en":"Job Title","jp":"職名"}}}


//////////////////
// WEBPACK FOOTER
// ./src/lib/langTemplates/OnboardUserTemplate.json
// module id = 96
// module chunks = 1